import state from './state';

export default {
  objektart: () => state.allgemeineAngaben.objektart,
  ermittlungsstichtag: () => state.allgemeineAngaben.ermittlungsstichtag,
  baujahr: () => state.allgemeineAngaben.baujahr,
  wohnungsnummer: () => state.allgemeineAngaben.wohnungsnummer,
  anzahlWohneinheiten: () => state.allgemeineAngaben.anzahlWohneinheiten,
  anzahlNutzeinheiten: () => state.allgemeineAngaben.anzahlNutzeinheiten,
  wohnflaeche: () => state.allgemeineAngaben.wohnflaeche,
  nutzflaeche: () => state.allgemeineAngaben.nutzflaeche,
  kernsanierung: () => state.allgemeineAngaben.kernsanierung,
  jahrDerKernsanierung: () => state.allgemeineAngaben.jahrDerKernsanierung,
  isValid: () => state.allgemeineAngaben.valid(),

  aussenwaendeModernisierung: () => state.aussenwaende.modernisierung,
  aussenwaendeJahrDerModernisierung: () => state.aussenwaende.jahrDerModernisierung,

  dachModernisierung: () => state.dach.modernisierung,
  dachJahrDerModernisierung: () => state.dach.jahrDerModernisierung,

  fensterModernisierung: () => state.fenster.modernisierung,
  fensterJahrDerModernisierung: () => state.fenster.jahrDerModernisierung,

  fussboedenModernisierung: () => state.fussboeden.modernisierung,
  fussboedenJahrDerModernisierung: () => state.fussboeden.jahrDerModernisierung,

  innenwaendeModernisierung: () => state.innenwaende.modernisierung,
  innenwaendeJahrDerModernisierung: () => state.innenwaende.jahrDerModernisierung,

  deckenModernisierung: () => state.decken.modernisierung,
  deckenJahrDerModernisierung: () => state.decken.jahrDerModernisierung,

  sanitaerModernisierung: () => state.sanitaer.modernisierung,
  sanitaerJahrDerModernisierung: () => state.sanitaer.jahrDerModernisierung,

  heizungModernisierung: () => state.heizung.modernisierung,
  heizungJahrDerModernisierung: () => state.heizung.jahrDerModernisierung,

  technischeAusstattungModernisierung: () => state.technischeAusstattung.modernisierung,
  technischeAusstattungJahrDerModernisierung: () =>
    state.technischeAusstattung.jahrDerModernisierung,
  isModernisierungenValid: () => state.modernisierungen.valid(),

  objektunterlagenGrundriss: () => state.objektunterlagen.grundriss,
  objektunterlagenZusatzdokumentGrundriss: () => state.objektunterlagen.zusatzdokumentGrundriss,
  objektunterlagenEnergieausweis: () => state.objektunterlagen.energieausweis,
  objektunterlagenZusatzdokumentEnergieausweis: () =>
    state.objektunterlagen.zusatzdokumentEnergieausweis,
  isObjektunterlagenValid: () => state.objektunterlagen.valid(),

  ansprechpartnerNachname: () => state.ansprechpartner.nachname,
  ansprechpartnerVorname: () => state.ansprechpartner.vorname,
  ansprechpartnerTelefon: () => state.ansprechpartner.telefon,
  ansprechpartnerErlaeuterung: () => state.ansprechpartner.erlaeuterung,
  alternateAnsprechpartnerName: () => state.ansprechpartner.altName,
  alternateAnsprechpartnerFunction: () => state.ansprechpartner.altFunktion,
  alternateAnsprechpartnerTelefon: () => state.ansprechpartner.altTelefon,
  alternateAnsprechpartnerEmail: () => state.ansprechpartner.altEmail,
  isAnsprechpartnerValid: () => state.ansprechpartner.valid(),

  defaultRechnungName1: () => state.defaultRechnung.name1,
  defaultRechnungName2: () => state.defaultRechnung.name2,
  defaultRechnungPlz: () => state.defaultRechnung.plz,
  defaultRechnungOrt: () => state.defaultRechnung.ort,
  defaultRechnungStr: () => state.defaultRechnung.str,
  defaultRechnungHnr: () => state.defaultRechnung.hnr,
  isDefaultRechnungValid: () => state.defaultRechnung.valid(),

  alternativeRechnungName1: () => state.alternativeRechnung.name1,
  alternativeRechnungName2: () => state.alternativeRechnung.name2,
  alternativeRechnungPlz: () => state.alternativeRechnung.plz,
  alternativeRechnungOrt: () => state.alternativeRechnung.ort,
  alternativeRechnungStr: () => state.alternativeRechnung.str,
  alternativeRechnungHnr: () => state.alternativeRechnung.hnr,
  useDefaultRechnung: () => state.alternativeRechnung.useDefault,
  isAlternativeRechnungValid: () => state.alternativeRechnung.valid(),

  isStillUploading() {
    function streamToBoolean(path) {
      return Object.values(path)
        .flatMap(a => a)
        .map(file => file?.isStillUploading())
        .reduce((a, b) => a || b);
    }

    return streamToBoolean({
      a: state.objektunterlagen.energieausweis,
      b: state.objektunterlagen.zusatzdokumentEnergieausweis,
      c: state.objektunterlagen.grundriss,
      d: state.objektunterlagen.zusatzdokumentGrundriss,
    });
  },
  exportData(state){
    let unwrap = ({ modernisierung, jahrDerModernisierung, erlaeuterung }) => ({
      modernisierung,
      jahrDerModernisierung,
      erlaeuterung,
    });
    return {
      allgemeineAngaben: (({
        ermittlungsstichtag,
        baujahr,
        wohnungsnummer,
        anzahlWohneinheiten,
        anzahlNutzeinheiten,
        wohnflaeche,
        nutzflaeche,
        kernsanierung,
        jahrDerKernsanierung,
      }) => ({
        ermittlungsstichtag,
        baujahr,
        wohnungsnummer,
        anzahlWohneinheiten,
        anzahlNutzeinheiten,
        wohnflaeche,
        nutzflaeche,
        kernsanierung,
        jahrDerKernsanierung,
      }))(state.allgemeineAngaben),
      aussenwaende: unwrap(state.aussenwaende),
      dach: unwrap(state.dach),
      fenster: unwrap(state.fenster),
      fussboeden: unwrap(state.fussboeden),
      innenwaende: unwrap(state.innenwaende),
      decken: unwrap(state.decken),
      sanitaer: unwrap(state.sanitaer),
      heizung: unwrap(state.heizung),
      technischeAusstattung: unwrap(state.technischeAusstattung),
      ansprechpartner: (({
        telefon,
        erlaeuterung,
        altName,
        altFunktion,
        altTelefon,
        altEmail
      }) => ({
          telefon,
          erlaeuterung,
          altName,
          altFunktion,
          altTelefon,
          altEmail
        }))(state.ansprechpartner),
      alternativeRechnung: (({
        name1,
        name2,
        plz,
        ort,
        str,
        hnr,
        useDefault,
      }) => ({
        name1,
        name2,
        plz,
        ort,
        str,
        hnr,
        useDefault,
      }))(state.alternativeRechnung),
    };
  },
  ausSpeicherGeladen: () => state.ausSpeicherGeladen,
};
